module.exports = __webpack_public_path__ + "media/images/icon_originals_l-4289519020e6deccd07686b3f19c09b9.png";